import React from 'react';
import { Table, Space } from 'antd';

const RowsTable = (props) => {
  const columns = props.columnsData;
  const dataSource = props.dataSource;
  return (
    <div>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={{ position: ['none', 'none'] }}
      />
    </div>
  );
};

export default RowsTable;
